import React from 'react';
import styled from '@emotion/native';
import { TouchableOpacity } from 'react-native';
import { secondaryHover, sand, mint } from '@/shared/styles/colors';
import { EditButton } from '@/shared/styles/styledComponents/editProfileForm';
import { DimensionValue } from 'react-native';
import useBreakpoint from '@/shared/hooks/useBreakpoint';
import AddIcon from './AddIcon';
import EditIcon from './EditIcon';
import { IS_WEB } from '../constants/utility';
import {
  GalleryImageType,
  getGalleryImageHeight,
} from '@/shared/utils/photoUtils';
import { GALLERY_CONSTANTS } from '../styles/constants';

interface GalleryButtonProps {
  onPress: () => void;
  imageUri?: string;
  flexBasis?: DimensionValue;
  imageType: GalleryImageType;
  backgroundColor?: string;
}

const GalleryButton: React.FC<GalleryButtonProps> = ({
  imageUri,
  onPress,
  flexBasis,
  imageType,
  backgroundColor = sand,
}) => {
  const { isDesktop } = useBreakpoint();

  const imageHeight = getGalleryImageHeight(imageType);

  return (
    <GalleryButtonContainer flexBasis={flexBasis} imageHeight={imageHeight}>
      <StyledTouchableOpacity
        onPress={onPress}
        activeOpacity={0.7}
        backgroundColor={backgroundColor}
      >
        <GalleryImageContainer>
          {imageUri ? (
            <>
              <GalleryImage source={{ uri: imageUri }} />
              <EditButton top={10} onPress={onPress}>
                <EditIcon size={isDesktop ? 26 : 32} />
              </EditButton>
            </>
          ) : (
            <AddIcon width={37} />
          )}
        </GalleryImageContainer>
      </StyledTouchableOpacity>
    </GalleryButtonContainer>
  );
};

export default GalleryButton;

const GalleryButtonContainer = styled.View<{
  flexBasis?: DimensionValue;
  imageHeight: number;
}>(({ flexBasis, imageHeight }) => ({
  flexBasis,
  height: imageHeight,
  borderRadius: GALLERY_CONSTANTS.BORDER_RADIUS,
}));

const StyledTouchableOpacity = styled(TouchableOpacity)<{
  backgroundColor: string;
}>(({ backgroundColor }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: GALLERY_CONSTANTS.BORDER_RADIUS,
  borderWidth: 0,
  flex: 1,
  padding: 0,
  margin: 0,
  backgroundColor,
}));

const GalleryImageContainer = styled.View({
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  width: '100%',
  height: '100%',
});

const GalleryImage = styled.Image({
  width: '100%',
  height: '100%',
  borderRadius: GALLERY_CONSTANTS.BORDER_RADIUS,
});
